import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans'
import FormInput from '../../../../library/form/components/FormInput';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormCheckbox from '../../../../library/form/components/FormCheckbox';
import FormRichText from '../../../../library/form/components/FormRichText';
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle';
import FormSearchButton from '../../../../library/form/components/FormSearchButton'
import FormLink from '../../../../library/form/components/FormLink';
import { UiGridColTwo, UiCol, UiRow, UiClear } from "../../../../library/layout/Index";

const BomHeaderEditor = (props) => {
    const { formObject, viewData, masterKeys, ...restProps } = props;

    if (!viewData)
        return (null)

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '300px', overflowY: 'scroll' }}
            formStyle={{ width: '660px', height: '400px' }} formTitle={<FormTitle formObject={formObject} masterKeys={masterKeys} />}
        >
            <UiGridColTwo>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "targetItemName" }} value="Target Item" />
                            </span>
                            <FormSearchButton formObject={formObject} rowKey="" headerKey='lineItemLink'
                                text={<SarasTrans value="Select Target" />} placeHolder="Barcode / Id..."
                                action={{ actionId: "refresh", actionParam: {} }}
                                className='uiActionButton uiSpacerH5'
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "targetItemName" }} value="Item Name" />
                            </span>
                            <FormLink formObject={formObject} rowKey="" linkProp={{ target: "_blank" }}
                                action={{ paramName: "targetItemName", actionId: "show", actionName: "itemComp" }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "type" }} value="Category" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "type", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': '%dataList.valLCat' } }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "subType" }} value="Sub Category" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "subType", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': '%dataList.valLCat' } }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "budget" }} value="Budget" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "input", paramName: "budget" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "designer1" }} value="1st Designer" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "designer1", acMethod: "ProfileName", acDepCtrl: { 'dparam': '%dataList.valLDT', reqPerm: 1 }  }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "designer2" }} value="2nd Designer" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "designer2", acMethod: "ProfileName", acDepCtrl: { 'dparam': '%dataList.valLDT', reqPerm: 1 } }} />
                        </li>
                    </ul>
                </UiCol>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "bomName" }} value="BOM Name" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "bomName" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "prodQty" }} value="BOM Qty" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "input", paramName: "prodQty" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "markup" }} value="Markup" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "input", paramName: "markup" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currency" }} value="Currency" />
                            </span>

                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "currency", acMethod: "CurrencyName" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "reserve" }} value="Reserve" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "reserve", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': '%dataList.valLCat' } }} />
                        </li>
                        <li style={{display:"none"}}>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qcTemplate" }} value="QC Template" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "qcTemplate", acMethod: "QCTemplate", acDepCtrl: { 'dparam': '%dataList.valLDT' } }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "endOn" }} value="Approved On (edit after approval)" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "dp", paramName: "endOn" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isActive" }} value="Active" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "isActive" }} />
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isDefault" }} value="Default" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "isDefault" }} />
                        </li>
                    </ul>
                </UiCol>
            </UiGridColTwo>
            <UiClear></UiClear>
                <UiRow>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comment" }} value="Comments" />
                    </span>
                    <FormRichText formObject={formObject} rowKey="" className="uiFrmText" rows="3" cols="82"
                        action={{ paramName: "comment" }}
                    />
                </UiRow>
        </FormDialog>
    )
}

export default withView(BomHeaderEditor, "bomHeader", "bomHeader")